module.exports = __webpack_public_path__ + "static/investors-cover-0e6031fb3798e25b35bca6c555ed71ab.jpg";